<template>
  <div
    class="irp-recommended-partners-table-skeleton"
    data-testid="irp-recommended-partners-table-skeleton"
  >
    <div class="irp-recommended-partners-table-skeleton__header">
      <div
        v-for="column in COLUMN_COUNT"
        :key="`partners-header__${column}`"
        class="irp-recommended-partners-table-skeleton__cell"
      >
        <BittsBone type="heading" class="w-4/5" />
      </div>
    </div>
    <div
      v-for="row in ROW_COUNT"
      :key="`partners-row__${row}`"
      class="irp-recommended-partners-table-skeleton__row"
      :class="{
        'irp-recommended-partners-table-skeleton__row--shaded': row % 2 === 1,
      }"
    >
      <div
        v-for="column in COLUMN_COUNT"
        :key="`partners-cell__${row}-${column}`"
        class="irp-recommended-partners-table-skeleton__cell"
      >
        <BittsBone
          v-if="column === PARTNER_COLUMN"
          type="avatar"
          size="small"
        />
        <BittsBone v-else type="copy" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsBone } from '@crossbeam/bitts';

const COLUMN_COUNT = 7;
const ROW_COUNT = 5;
const PARTNER_COLUMN = 1;
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-recommended-partners-table-skeleton__header {
  @apply flex items-center w-full bg-neutral-background;
}

.irp-recommended-partners-table-skeleton__row {
  @apply flex items-center w-full;
}

.irp-recommended-partners-table-skeleton__row--shaded {
  @apply bg-neutral-background-weak;
}

.irp-recommended-partners-table-skeleton__cell {
  @apply w-full p-16;
}
</style>
